import { defineStore } from 'pinia'
import { skillsApi } from '@/api/modules/skills'
import { getApiConfig } from '@/config/api'
import { mockSkillDetail, mockFiles, mockChangelogs } from '@/mock'

const enableMock = getApiConfig().enableMock

export const useSkillsStore = defineStore('skills', {
  state: () => ({
    list: [],
    currentSkill: null,
    changelog: [],
    files: [],
    loading: false
  }),

  getters: {
    activeSkills: (state) => state.list.filter((s) => s.active),
    getSkillById: (state) => (id) => state.list.find((s) => s.id === id)
  },

  actions: {
    async fetchList() {
      this.loading = true
      try {
        // if (enableMock) {
        //   // 使用 Mock 数据
        //   this.list = mockSkills
        // } else {
        //   this.list = await skillsApi.getList()
        // }
        this.list = await skillsApi.getList()
      } catch {
        // API 失败时降级使用 Mock 数据
        // this.list = mockSkills
      } finally {
        this.loading = false
      }
    },

    async fetchDetail(skillId) {
      this.loading = true
      try {
        if (enableMock) {
          // 使用 Mock 数据
          this.currentSkill = mockSkillDetail
          this.changelog = mockChangelogs
          this.files = mockFiles
        } else {
          this.currentSkill = await skillsApi.getDetail(skillId)
          this.changelog = await skillsApi.getChangelog(skillId)
          this.files = await skillsApi.getFiles(skillId)
        }
      } catch {
        // API 失败时降级使用 Mock 数据
        this.currentSkill = mockSkillDetail
        this.changelog = mockChangelogs
        this.files = mockFiles
      } finally {
        this.loading = false
      }
    },

    clearCurrent() {
      this.currentSkill = null
      this.changelog = []
      this.files = []
    }
  }
})
